import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The joy of being a beginner",
  "description": "",
  "published": "2018-10-03T00:00:00.000Z",
  "redirect_from": ["/blog/joy-beginner/swizec/8628"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A month ago, I published `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/tired-poem/swizec/8560"
      }}>{`I'm tired`}</a>{` and realized it's time to make some changes. Too much hustle, too much work, too much everything.`}</p>
    <p>{`So I'm trying a new hobby: motorcycles.`}</p>
    <p>{`Here's me sitting on a real bike for the first time. At the shop, just trying it on for size. 👇`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`I’m in love, this is happening as soon as I figure out if I’m getting deported end of September or not. `}<a parentName="p" {...{
          "href": "https://t.co/QZ9fSaDxAI"
        }}>{`pic.twitter.com/QZ9fSaDxAI`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1030962256975093760"
      }}>{`August 18, 2018`}</a></blockquote>
    <p>{`Look at that face! Pure excitement.`}</p>
    <p>{`But before you buy a bike, you need to learn how to ride a bike. And get a license.`}</p>
    <p>{`You `}<em parentName="p">{`can`}</em>{` buy a bike without either of those things, but what good is a bike if you can't even drive it out of the store? I barely felt confident enough to sit on it, let alone make it move.`}</p>
    <p>{`Cue the `}<a parentName="p" {...{
        "href": "http://motorcycleschool.com/"
      }}>{`Bay Area Motorcycle Training`}</a>{` course. A 2-day course that takes you from `}<em parentName="p">{`"never sat on a bike"`}</em>{` to `}<em parentName="p">{`"you're not an immediate threat to yourself and others and we think you'll be okay probably"`}</em>{`.`}</p>
    <p>{`How much can you really learn in 2 days, right? Qualified to ride any parking lot in the US 🤘`}</p>
    <p>{`You'd be surprised!`}</p>
    <p>{`I passed the course this weekend, and while I could barely keep my little Honda Rebel 250cc from dropping on Saturday morning, I was whizzing around doing fun evasive maneuvers and emergency stops from 20mph by Sunday afternoon.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Fuck Javascript this is gonna be way more fun `}<a parentName="p" {...{
          "href": "https://t.co/TrFNxsZx7E"
        }}>{`pic.twitter.com/TrFNxsZx7E`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1046109347061927936"
      }}>{`September 29, 2018`}</a></blockquote>
    <p>{`Bikes are fun!`}</p>
    <h2 {...{
      "id": "being-a-beginner"
    }}>{`Being a beginner`}</h2>
    <p>{`My favorite part was learning something new. Something completely outside my comfort zone.`}</p>
    <p>{`You sit on the bike, and it's heavy and wobbly and you're sure you're gonna drop it. You sort of hold it still with your butt.`}</p>
    <p>{`Then you turn on the engine, and holy shit it's loud! So much noise! And it smells like gasoline. And the whole thing shakes and vibrates as it desperately tries to warm up the engine.`}</p>
    <p>{`They gave us old bikes. You have to use the choke to make it run cold. Gives it a richer fuel-to-air mixture.`}</p>
    <p>{`Excitement! Fear! Big smiles.`}</p>
    <p>{`Over those two afternoons of riding, we went through 20 exercises. Starting with feeling the clutch, letting it out just enough to rock the bike from your heels to your toes.`}</p>
    <p>{`Bike sure doesn't wanna go that slow. Easy to make it jump and drop you on your bum.`}</p>
    <p>{`We progressed to straddle walking where the bike pulls forward and you walk with it. Then going straight. Then slow turns. And by the end of the day, we were doing death defying feats of pure adrenaline: wide turns at 12mph without slowing down.`}</p>
    <p>{`😎`}</p>
    <h2 {...{
      "id": "so-speed-much-wow"
    }}>{`SO SPEED! MUCH WOW`}</h2>
    <p>{`You have no idea how fast that 12mph turn felt. I ran wide every single time.`}</p>
    <p>{`The instructor said `}<em parentName="p">{`"Good speed. But why are you slowing down in the turn? That makes you run wide"`}</em></p>
    <p>{`I'M SLOWING DOWN BECAUSE THIS IS FUCKING TERRIFYING WHAT DO YOU MEAN I HAVE TO GO FASTER TO TURN TIGHTER THAT MAKES NO SENSE`}</p>
    <p>{`Motorcycles are heavy. When you reach 12 to 13 miles per hour, physics stops working.`}</p>
    <p>{`You see, on a bicycle, you lean and the bicycle leans. On a motorcycle with a bit of speed, you lean and nothing happens.`}</p>
    <p>{`Like, nothing.`}</p>
    <p>{`I didn't believe them at first, but it became obvious during the swerving maneuver on day 2. You go fast, you throw all your weight to one side, barely staying on the bike. Bike keeps going straight.`}</p>
    <p>{`Instead, you have to `}<em parentName="p">{`turn the wrong way`}</em>{`. This makes the bike fall out of where you're turning and into the turn. Then it makes the turn. `}<em parentName="p">{`While you keep steering the wrong way`}</em></p>
    <p>{`Slowing down or turning in stands up the bike and makes you run wide.`}</p>
    <p><img parentName="p" {...{
        "src": "/8ea40ab6c639c0257ed3d7ee0f1d47e6/media-26ufdipQqU2lhNA4g-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`A trick they make you use for counter steering is to look very deep into the turn. That forces you to push off the handlebars and turn the wrong direction without realizing it.`}</p>
    <p>{`Short-circuits your brain. It's best not to think.`}</p>
    <p>{`But it `}<em parentName="p">{`really`}</em>{` clicked during the swerve maneuver. There, you have to cross your heart and just trust. Trust that you will turn aggressively in the wrong direction and the bike will go in the right direction and you will not fall.`}</p>
    <p>{`It's fun. Terrifying. But so much fun. Swerving was my favorite.`}</p>
    <p>{`Feels like you're gonna fall, but it works out! The suspension suspenses, the bike leans to one side then the other, you stay upright, the thing bucks and weaves between your legs, and you're around the obstacle. No speed lost. I even added throttle every time. 😇`}</p>
    <p>{`Trust.`}</p>
    <h2 {...{
      "id": "now-what"
    }}>{`Now what?`}</h2>
    <p>{`Now all I need is a bike. A nice Triumph Bonneville Bobber Black. Way too expensive for a first bike. Way too nice. Way too heavy.`}</p>
    <p>{`BUT I WANTS IT IT IS BEAUTIFUL`}</p>
    <p>{`Think the fastest I can get my real M1 license following this course is two weeks 🤔`}</p>
    <p>{`Bureaucracy.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      